/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeGoogleAnalyticsScriptsData } from './moe-google-analytics-scripts.data';
import { IMoeGoogleAnalyticsScriptsProps } from './moe-google-analytics-scripts.props.autogenerated';

export interface IMoeGoogleAnalyticsScriptsViewProps extends IMoeGoogleAnalyticsScriptsProps<IMoeGoogleAnalyticsScriptsData> {}

/**
 *
 * MoeGoogleAnalyticsScripts component
 * @extends {React.PureComponent<IMoeGoogleAnalyticsScriptsProps<IMoeGoogleAnalyticsScriptsData>>}
 */
class MoeGoogleAnalyticsScripts extends React.PureComponent<IMoeGoogleAnalyticsScriptsProps<IMoeGoogleAnalyticsScriptsData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeGoogleAnalyticsScripts;
